module.exports = __webpack_public_path__ + "img/flushed.a08c7ce0.gif";